import React, { Component } from "react";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { Button, Modal, FormControl } from "react-bootstrap";
import { invokeCreateProgramFolder } from "../../utils/AwsInvoke";
import "../../css/modal/ModalCreateFolder.css";
import "../../css/modal/ModalBasics.css";

export default class ModalCreateFolder extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalSimple: false,
            folder_name: "",
            error: ""
        };
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            folder_name: "",
            error: ""
        });
    }

    handleFolderNameChange (event) {
        var folder_name = event.target.value;

        this.setState({
            folder_name: folder_name
        });
    }

    handleSubmit = async event => {
        var name = this.state.folder_name;

        if(name != "" ) {
            const results = await invokeCreateProgramFolder(name);

            if(results.status != null) {
                // Close Modal //
                this.props.onHide();
                this.props.getProgramList(""); // "": search all
                //alert("Your folder was created.")
            }
        } else {
            this.setState({
                error: "You must enter a folder name."
            })
        }
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
             this.handleSubmit();
        }
    }

    render() {
        var notes = this.props.notes;
        var error = this.state.error;
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <FontAwesomeIcon icon="folder-open" className="modalBasicsTitleIcon" />
                        <span className="modalBasicsTitle">
                             Create Program Folder
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="modalBasicsBody">
                          Store your programs into organized folders.
                          <br/><br/>
                          <div>
                              <div className="modalFormLabelBody">Program Folder Name</div>
                              <FormControl
                                  onChange     = {this.handleFolderNameChange.bind(this)}
                                  defaultValue = {""}
                                  className    = "input-lg formModalExerciseField"
                                  type         = "text"
                                  onKeyPress   = {this.handleKeyPress}
                              />
                          </div>
                          <span style={{paddingTop:15, fontSize: 16, color: "red"}}>{error}</span>
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    <Button className="modalBasicsBtnOk" onClick={() => this.handleSubmit()}>Save</Button>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalCreateFolder.js